import { Reveal, Eyebrow } from "../components/Reveal";

const CARDS = [
  {
    title: "Homeowners",
    img: "https://images.unsplash.com/photo-1713942590368-09cfc6ae94ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Family at their home",
  },
  {
    title: "Families",
    img: "https://images.unsplash.com/photo-1624448445915-97154f5e688c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Diverse multigenerational family together",
  },
  {
    title: "Veterans",
    img: "https://images.pexels.com/photos/7984335/pexels-photo-7984335.jpeg?auto=compress&cs=tinysrgb&w=900",
    alt: "Proud soldier in military uniform with his family beside him",
  },
  {
    title: "Business Owners",
    img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Confident Black business woman in a professional setting",
  },
  {
    title: "Building Wealth",
    img: "https://images.unsplash.com/photo-1758686253692-2d6921de12dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Couple reviewing their future together at home",
  },
  {
    title: "Want Privacy",
    img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    alt: "Person looking confidently forward in a professional setting",
  },
];

export const WhoWeServe = () => (
  <section className="bg-ink py-24 sm:py-36" data-testid="who-we-serve-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Who We Serve</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-cream tracking-tight leading-[1.06] mt-6">
          This Is For You <em className="text-gold italic">If...</em>
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 mt-14 sm:mt-20">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={0.08 * i}>
            <div className="group relative rounded-2xl overflow-hidden h-80 sm:h-96 border border-white/8" data-testid={`serve-card-${i}`}>
              <img
                src={c.img}
                alt={c.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/25 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-7">
                <span className="block h-0.5 w-8 bg-gold mb-4 group-hover:w-14 transition-[width] duration-500" />
                <h3 className="font-display text-2xl sm:text-3xl text-cream">{c.title}</h3>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
